import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { useAdminDashboard } from "@/features/admin";
import { formatDuration } from "@/features/utils/numbers";
import { useState } from "react";
import { ActivityChart } from "../../backoffice/dashboard/components/activity-chart";
import { AdminPageLayout } from "../layout";
import { PeriodSelect } from "./components/period-select";
import { StatCard } from "./components/stat-card";

/** Global (all-tenant) dashboard for platform staff. */
export function AdminDashboardPage() {
  const [days, setDays] = useState(30);
  const { data, isLoading } = useAdminDashboard(days);

  return (
    <AdminPageLayout
      title="Vue globale"
      description="Indicateurs agrégés sur l'ensemble des tenants"
      actions={[<PeriodSelect days={days} onChange={setDays} />]}
    >

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <StatCard
          title="Minutes totales"
          value={formatDuration((data?.total_minutes ?? 0) * 60)}
          isLoading={isLoading}
        />
        <StatCard
          title="Clients (tenants)"
          value={data?.total_clients ?? 0}
          isLoading={isLoading}
        />
        <StatCard
          title="Appels"
          value={data?.total_calls ?? 0}
          hint={`${data?.total_sessions ?? 0} sessions au total`}
          isLoading={isLoading}
        />
        <StatCard
          title="Clients finaux uniques"
          value={data?.unique_customers ?? 0}
          isLoading={isLoading}
        />
      </div>

      {isLoading ? (
        <Card>
          <CardHeader>
            <Skeleton className="h-6 w-32" />
          </CardHeader>
          <CardContent>
            <Skeleton className="h-[300px] w-full" />
          </CardContent>
        </Card>
      ) : (
        <ActivityChart data={data?.sessions_by_day || []} days={days} />
      )}
    </AdminPageLayout>
  );
}
